export function initContentUi($) {
  // Special style for askerisks wrap
  $("h1, h2, h3, h4, h5, h6, .hero-title").html(function (i, html) {
    return html.replace(/\*(.*?)\*/g, '<span class="highlight">$1</span>');
  });
  
  //match height
  // Lottie artwork may overflow its card; do not equalize cards by animation height.
  $(".solution-types .solution-types_wrap").css("height", "");
  $("#tab-1 .pricing-main").matchHeight();
  $("#tab-2 .pricing-main").matchHeight();
  $("#tab-3 .pricing-main").matchHeight();
  $(".blog-related .blog-related_text").matchHeight();
  $(".blog-related .blog-related_title").matchHeight();
  $(".posts-container .posts_text").matchHeight();
  $(".posts-container .posts_title").matchHeight();
  $(".posts-container .posts_info").matchHeight();
  $(".blog-related_outer .blog-related_title").matchHeight();
  $(".blog-related_outer .blog-related_info").matchHeight();
  $(".columns .columns_title").matchHeight();
  $(".recommend-content .recommend-content_title").matchHeight();
  $(".recommend-content .recommend-content_text").matchHeight();
  $(".recommend-content .recommend-content_info").matchHeight();
  $(".job-card .job-title").matchHeight();
  $(".job-card .job-desc").matchHeight();
  $(".job-pill").matchHeight();
  $("#tab-0 .pricing-main h3").matchHeight();
  $("#tab-0 .pricing-main .pricing-price").matchHeight();
  
  $(window).on("load", function () {
    $(".book-demo_logos .logo").matchHeight();
  });
  
  // Keep ring motion CSS-driven to avoid per-frame JS transform rewrites on logos.
  // $('.rotating-slider').each(function () {
  // 	const $ring = $(this);
  // 	if ($ring.data('ringReady')) return;
  
  // 	$ring.data('ringReady', true);
  // 	$ring.css('--ring-duration', '80s');
  // });
  
  const trustStatsNextSelectors = [
    "section.rotating-slider",
    "section.solution-roles",
    "section.product-feature",
    "section.trust-stats",
    "section.thin-text",
    "section.recommend-content.bg-filled",
    "section.faq",
    "section.columns.bg-filled",
    "section.two-columntext",
    "section.video-display",
    "section.featured-products",
  ].join(", ");
  
  $("section.trust-stats").each(function () {
    const $trustStats = $(this);
    const $nextSection = $trustStats.next();
  
    if ($nextSection.is(trustStatsNextSelectors)) {
      $trustStats.addClass("no-tail");
    } else {
      $trustStats.removeClass("no-tail");
    }
  });
  
  const blocksWithMargin = [
    "section.rotating-slider",
    "section.product-feature",
    "section.trust-stats",
    "section.thin-text",
    "section.recommend-content.bg-filled",
    "section.faq",
    "section.columns.bg-filled",
    "section.two-columntext",
    "section.featured-products",
  ].join(", ");
  
  $("section.solution-types").each(function () {
    const $solTypes = $(this);
    const $nextSection = $solTypes.next();
  
    if ($nextSection.is(blocksWithMargin)) {
      $solTypes.addClass("adjusted-margin");
    } else {
      $solTypes.removeClass("adjusted-margin");
    }
  });
}
